export const BREAKPOINT_CHANGED = 'breakpointChanged';

/* eslint-disable no-underscore-dangle */
// TODO: extend EventTarget once we drop IE11 support
export class BreakpointObserver {
	private rootElement: HTMLElement;
	private _value: string;
	private listeners: { [key: string]: Set<Function> };

	public get value() {
		return this._value;
	}
	constructor(rootElement?: HTMLElement) {
		this.listeners = {};
		this.rootElement = rootElement ? rootElement : document.body;
		this._value = this.getBreakpoint();
		this.listen();
		this.refreshValue();
	}
	addEventListener(type: string, callback: Function) {
		if (!(type in this.listeners)) {
			this.listeners[type] = new Set<Function>();
		}
		this.listeners[type].add(callback);
	}
	removeEventListener(type: string, callback: Function) {
		if (!(type in this.listeners)) {
			return;
		}
		this.listeners[type].delete(callback);
	}
	dispatchEvent(event: Event) {
		if (!(event.type in this.listeners)) {
			return true;
		}
		const stack = Array.from(this.listeners[event.type]).slice();

		for (let i = 0, l = stack.length; i < l; i++) {
			stack[i].call(this, event);
		}
		return !event.defaultPrevented;
	}
	listen() {
		window.addEventListener('resize', this.refreshValue);
	}
	unlisten() {
		window.removeEventListener('resize', this.refreshValue);
	}
	private getBreakpoint = () => {
		return window
			.getComputedStyle(this.rootElement, ':before')
			.getPropertyValue('content')
			.replace(/\"/g, '');
	};
	private refreshValue = () => {
		const oldValue = this._value;
		const newValue = this.getBreakpoint();
		this._value = newValue;

		if (newValue !== oldValue) {
			const e = new CustomEvent(BREAKPOINT_CHANGED, {
				detail: { breakpoint: newValue, previousBreakpoint: oldValue },
			});
			this.dispatchEvent(e);
		}
	};
}

export default BreakpointObserver;
/* eslint-enable */
